/**
 * Registry of known Provider Portal feature-flag keys.
 *
 * Keys are mirrored from the Java enum
 * {@code org.xolv.portal.featureflag.providerportal.ProviderPortalFeatureFlags}
 * in provider-be. Add an entry here when a new flag is introduced, then reference it
 * through {@link useFeatureFlag} instead of hard-coding the string.
 */
export const ProviderPortalFeatureFlag = {
    BHPNPP_3077_IS_TWO_WAY_MESSAGING_DISABLED: 'bhpnpp-3077-is-two-way-messaging-disabled',
    TDTL_9900_IS_EXPORT_DISABLED: 'tdtl-9900-is-export-disabled',
    TDTL_9950_UPDATED_TRANSFER_REQUEST_DISABLED: 'tdtl-9950-updated-transfer-request-disabled',
    BHPNPP_2410_IS_REMOVE_REPORT_FILE_DISABLED: 'bhpnpp-2410-is-remove-report-file-disabled',
    BHPNPP_3195_DUAL_PROVIDER_CARE_COORDINATION_ENABLED: 'bhpnpp-3195-dual-provider-care-coordination-enabled',
    BHPNPP_3219_PROGRESS_PORTRAIT_DISABLED: 'bhpnpp-3219-progress-portrait-disabled',
    BHPNPP_3236_IS_UTILIZED_HOURS_DISABLED: 'bhpnpp-3236-is-utilized-hours-disabled',
    BHPNPP_3240_IS_BIZ_CONTACT_DISABLED: 'bhpnpp-3240-is-biz-contact-disabled'
} as const;

/**
 * Known Provider Portal feature-flag keys.
 *
 * Currently a {@code string} alias because no flags are registered yet. Once entries are
 * added to {@link ProviderPortalFeatureFlag}, change this to a union derived from the object.
 */
export type ProviderPortalFeatureFlagKey = string;
